export default __webpack_public_path__ + "static/launch-partner_SilverPoet_logo@2x-ddfffa413ce3d91b014da9cc8c4a2780.png";